import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Routes from './routes'

import SeedClassTable from 'views/pages/SeedClass/SeedClassTable'
import SeedClassEdit from './SeedClassEdit'
import SeedClassAdd from './SeedClassAdd'

const SeedClassPage = () => {
  return (
    <Switch>
      <Route path={Routes.List} exact={true}>
        <SeedClassTable />
      </Route>
      <Route path={Routes.Edit} exact={true}>
        <SeedClassEdit />
      </Route>
      <Route path={Routes.Add} exact={true}>
        <SeedClassAdd />
      </Route>
      <Redirect to={Routes.List} />
    </Switch>
  )
}

export default SeedClassPage
